'use client'

import { Icon } from '@/ui/components'

import { cn } from '@/lib/utils'
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput
} from '@/ui/Shadcn/input-group'

interface InputSearchProps
  extends React.ComponentProps<typeof InputGroupInput> {
  className?: string
  id?: string
  showPlaceholder?: boolean
  [key: string]: any
}

function InputSearch({
  placeholder = '',
  className,
  id,
  ...props
}: InputSearchProps) {
  return (
    <InputGroup
      className={cn('px-md py-xs input-focus h-auto bg-neutral-200', className)}
    >
      <InputGroupInput
        id={id}
        className="text-neutral-600"
        placeholder={placeholder}
        {...props}
      />
      <InputGroupAddon className="h-[1.5rem] w-[1.5rem] p-0 text-neutral-600">
        <Icon icon="material-symbols:search" className="h-full! w-full!" />
      </InputGroupAddon>
    </InputGroup>
  )
}

InputSearch.displayName = 'InputSearch'

export default InputSearch
